export default __webpack_public_path__ + "static/media/single.ee71184c.jpg";